import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';
import { reducedMotion } from '@/shared/ui/theme';

const baseLabel = {
  display: 'inline-flex',
  alignItems: 'baseline',
  gap: '0.35em',
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: '0.75rem',
  fontWeight: String(500),
  color: vars.typography.textColor.tertiary,
};

export const staticLabel = style(baseLabel);

// H-2 — 마감 CTA 주입 시 band를 좌(카운터)/우(버튼)로 분리. windowFooter가 flex-end라
// width:100% + space-between으로 양 끝 배치.
export const root = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.75rem',
  width: '100%',
});

// band 높이에 맞는 컴팩트 primary 마감 CTA. 메모 내 submitBtn(0.875rem·40px)보다는 작지만
// band 카운터보다 시선을 끌도록 한 단계 키움.
export const sealBtn = style({
  flexShrink: 0,
  padding: '0.45rem 1.1rem',
  borderRadius: '6px',
  border: 'none',
  cursor: 'pointer',
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: '0.8125rem',
  fontWeight: String(600),
  color: vars.typography.textColor.primary,
  background: vars.bright.primary.dark,
  transition: `opacity ${vars.animation.duration.fast}`,
  selectors: {
    '&:hover': { opacity: 0.85 },
    '&:disabled': { opacity: 0.4, cursor: 'not-allowed' },
    '&:focus-visible': {
      outline: `${vars.focus.ring.width} ${vars.focus.ring.style} ${vars.focus.ring.color}`,
      outlineOffset: vars.focus.ring.offset,
    },
  },
  '@media': {
    [reducedMotion]: { transition: 'none' },
  },
});

export const archiveLink = style({
  ...baseLabel,
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  padding: '0.25rem 0.625rem',
  borderRadius: '6px',
  transition: `color ${vars.animation.duration.fast}, background ${vars.animation.duration.fast}`,
  selectors: {
    '&:hover': {
      color: vars.bright.primary.light,
      background: vars.surface.highlight.light,
    },
    '&:focus-visible': {
      outline: `${vars.focus.ring.width} ${vars.focus.ring.style} ${vars.focus.ring.color}`,
      outlineOffset: vars.focus.ring.offset,
    },
  },
  '@media': {
    [reducedMotion]: { transition: 'none' },
  },
});

export const separator = style({
  color: vars.typography.textColor.disabled,
});

export const count = style({
  fontFamily: vars.typography.fontFamily.mono,
  fontVariantNumeric: 'tabular-nums',
  fontWeight: String(600),
  color: vars.bright.primary.light,
});
